module.exports = __webpack_public_path__ + "static/media/star.b0bdf540.svg";